import dayjs from 'dayjs'

export const filtersDefault = {
  /** Default from date for filters (30 latest days) */
  fromDate: dayjs().subtract(30, 'day').format('YYYY-MM-DD'),
  /** Default to date for filters */
  toDate: dayjs().format('YYYY-MM-DD'),
}
